import React, {useEffect, useState} from 'react'
import {Button, Card, Col, Container, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import ControlUnitsTable from "../../Components/ControlUnitsTable/ControlUnitsTable";
import './ControlUnitsPage.css'
import {ControlUnitService} from "./ControlUnitService";
import {SELECT_CONTROL_UNIT, SET_LAST_CONTROL_UNIT_TIME_INTERVAL} from "../../Store/ActionTypes/General/actionTypes";
import {useContext} from "react";
import {store} from "../../Store/store";
import {Link} from "react-router-dom";
import {CgList} from "react-icons/cg";
import StatusLegendModal from "./StatusLegendModal";
import {MULTI_SELECT} from "../Errors/Constants/Constants";

export default function ControlUnitsPage() {
    const controlUnitService = new ControlUnitService(process.env.REACT_APP_SUPPORT_DASHBOARD_CONTROL_UNITS_URL);
    const POLLING_TIME_INTERVAL = 15000;
    const {dispatch} = useContext(store);
    const stateObj = useContext(store);
    const controlUnitPageLastTimeInterval = stateObj.state.lastControlUnitTimeInterval;
    const [clmShow, setClmShow] = useState(false);

    const controlUnitFormatter = (cell, row, pageIndex) => {
        return (<Link onClick={() => {
            selectControlUnit(row);
        }} to={`controlUnits/${row.id}?page=${pageIndex}`}>{cell}</Link>);
    }

    const selectControlUnit = (object) => {
        dispatch({
            type: SELECT_CONTROL_UNIT, payload: object
        });
    }

    const setStateLastTimeInterval = (timeInterval) => {
        dispatch({
            type: SET_LAST_CONTROL_UNIT_TIME_INTERVAL, payload: timeInterval
        });
    }

    const populateControlUnitsData = async () => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const pageParam = urlParams.get('page');
            const pageIndex = pageParam ? parseInt(pageParam) : 0;
            const savedFilters = sessionStorage.getItem('controlUnitsTableFilters');
            const columnFilters = savedFilters ? JSON.parse(savedFilters) : [];
            let columnFiltersQuery = null;
            if (columnFilters.length > 0) {
                const statusFilterOptions = [
                    { value: 'CONNECTED', label: 'Connected' },
                    { value: 'DISCONNECTED', label: 'Disconnected' },
                    { value: 'UNKNOWN', label: 'Unknown' }
                ];
                const loggingFilterOptions = [
                    { value: 'FATAL', label: 'Fatal' },
                    { value: 'ERROR', label: 'Error' },
                    { value: 'WARNING', label: 'Warning' },
                    { value: 'INFO', label: 'Info' },
                    { value: 'DEBUG', label: 'Debug' }
                ];
                const lifecyclePhaseFilterOptions = [
                    {value: 'ENROLLED', label: 'Enrolled'},
                    {value: 'PRE_SERVICE', label: 'Pre-Service'},
                    {value: 'IN_SERVICE', label: 'In-Service'},
                    {value: 'INTERNAL_USE', label: 'Internal Use'},
                    {value: 'DECOMMISSIONED', label: 'Decommissioned'},
                    {value: 'HARDWARE_DONOR', label: 'Hardware Donor'},
                ];
                const columnFilterTypes = {
                    'connectionState': { type: 'select', options: statusFilterOptions },
                    'stateLogging': { type: 'select', options: loggingFilterOptions },
                    'name': { type: 'text' },
                    'siteName': { type: 'text' },
                    'serialNumber': { type: 'text' },
                    'lifecyclePhase': { type: MULTI_SELECT, options: lifecyclePhaseFilterOptions }
                };
                columnFiltersQuery = '';
                columnFilters.forEach((filter, index) => {
                    const filterId = filter.id.includes('.') ? filter.id.split('.')[0] : filter.id;
                    columnFiltersQuery += index !== 0 ? ';' : '';

                    const filterType = columnFilterTypes[filterId]?.type || 'text';

                    switch (filterType) {
                        case 'select':
                            const filterOptions = columnFilterTypes[filterId].options;
                            const filterValue = filterOptions.find((obj) => filter.value === obj.label);
                            if (filterValue) {
                                columnFiltersQuery += `${filterId}=='${filterValue.value}'`;
                            }
                            break;
                        case 'number':
                            const numberValue = filter.value.number;
                            const numberOperator = filter.value.operator;
                            columnFiltersQuery += `${filterId}${numberOperator}'${numberValue}'`;
                            break;
                        case 'multi-select':
                            const filterOpts = columnFilterTypes[filterId].options;
                            let filteredItems = filterOpts.filter(obj => {
                                return filter.value.includes(obj.label)
                            });
                            filteredItems = filteredItems.map(it => `\'${it.value}\'`).join(',');
                            columnFiltersQuery += `${filterId}=in=(${filteredItems})`;
                            break;
                        default:
                            columnFiltersQuery += `${filterId}=ilike='${filter.value}'`;
                            break;
                    }
                });
            }
            await controlUnitService.getControlUnitsData(columnFiltersQuery, null, pageIndex, 15);
        } catch (error) {
            console.error("Error fetching control units data:", error);
        }
    }

    useEffect(() => {
        clearInterval(controlUnitPageLastTimeInterval);
        populateControlUnitsData();
        const timeInterval = setInterval(async () => {
            await populateControlUnitsData();
        }, POLLING_TIME_INTERVAL);
        setStateLastTimeInterval(timeInterval);
    }, [])

    return (
        <Container fluid>
            <br/>
            <Col xs={12}>
                <Row>
                    <Col>
                        <Card>
                            <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div className={'d-inline-block pr-2'}>
                                    </div>
                                    <div className={'d-inline-block'}>
                                        Control Units
                                    </div>
                                    <div className={'d-inline-block'}>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip>Status Legend</Tooltip>
                                            }>
                                            <Button variant="light" onClick={() => setClmShow(true)}><CgList/></Button>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <StatusLegendModal show={clmShow} setShow={setClmShow}/>
                            </Card.Header>
                            <Card.Body>
                                <ControlUnitsTable
                                    controlUnitFormatter={controlUnitFormatter}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Container>
    )
}
